import { Button, Card, Image, Modal, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PhotoProductService from "../../../../service/PhotoProductService";
import AddPhotoProduct from "./AddPhotoProduct";
// import EditPhotoProduct from "./EditPhotoProduct";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_IMG_PRODUCT } from "../../../../configs/AppConfig";

const { confirm } = Modal;

const PhotoProduct = () => {
  const [openAdd, setOpenAdd] = useState({
    open: false,
    photoProductId: "",
  });

  const [loading, setLoading] = useState(false);

  const [openEdit, setOpenEdit] = useState({
    open: false,
    photoProductId: "",
  });
  const [PhotoProduct, setPhotoProduct] = useState<any>([]);
  const [newPhotoProductId, setNewPhotoProductId] = useState("");

  const showDrawerAdd = async () => {
    setOpenAdd({
      open: true,
      photoProductId: "",
    });
  };

  const showDrawerEdit = (record: any) => {
    setOpenEdit({ open: true, photoProductId: record._id });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await PhotoProductService.fetchFilter(1);

      setPhotoProduct({
        data: result.data.productPhotos,
        total: result.data.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "图片",
      dataIndex: "img",
      key: "img",
      width: "70%",

      render: (text: string, record: any) => (
        <>
          <Image width={200} src={API_IMG_PRODUCT + text} />
        </>
      ),
    },

    {
      title: "更多",
      key: "action",

      render: (text: string, record: any) => (
        <>
          <Space size="middle">
            <Button
              danger
              type="primary"
              onClick={() => {
                deletePhotoProductConfirm(record._id);
              }}
            >
              删除
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const res = await PhotoProductService.fetchFilter(page);
    setPhotoProduct({
      data: res.data.productPhotos,
      total: res.data.total,
    });
    setLoading(false);
  };

  const deletePhotoProduct = async (id: string) => {
    await PhotoProductService.delete(id);
    window.location.reload();
  };

  const deletePhotoProductConfirm = (id: string) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      title: "确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        deletePhotoProduct(id);
      },
    });
  };

  return (
    <Card>
      <Button
        onClick={showDrawerAdd}
        style={{
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          backgroundColor: "green",
        }}
        type="primary"
      >
        添加
      </Button>
      <Table
        loading={loading}
        dataSource={PhotoProduct.data}
        columns={columns}
        rowKey="_id"
        pagination={{
          pageSize: 12,
          total: PhotoProduct.total,
          onChange: pageChangeHandle,
        }}
      />
      {openAdd && (
        <AddPhotoProduct openData={openAdd} setOpenData={setOpenAdd} />
      )}
      {/* {openEdit.open && (
        <EditPhotoProduct openData={openEdit} setOpenData={setOpenEdit} />
      )} */}
    </Card>
  );
};

export default PhotoProduct;
